// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay-module__overlay___x6JCH","content":"Overlay-module__content___nZOXv"};